import { render, staticRenderFns } from "./ResultAnim.vue?vue&type=template&id=b68566ca&"
import script from "./ResultAnim.vue?vue&type=script&lang=js&"
export * from "./ResultAnim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports